import InfoPersoRecapFormComponent from '../../components/info-perso/InfoPersoRecapFormComponent';

export default function InfoPersoRecapBloc() {

      return (
        <div className="">
          <div className="">
            <InfoPersoRecapFormComponent />  
          </div>
        </div>
      )
}